
// TODO : ModifyAdsSection(section)
// ModifyAdsSection('home')>'Home'

import _ from 'lodash';
import adsData from 'src/components/ads/ads-data.json';

export function ModifyAdsSection (section = '') {
  const firstOfSection = section?.charAt(0);
  const parseToUppercase = firstOfSection?.toLocaleUpperCase();
  const newSection = section?.replace(section.charAt(0), parseToUppercase);
  return newSection;
}

export function ModifyAdsSlot ({ adsName = '', section = '' }) {
  const adsSection = adsData.filter((data) => data.section === section)[0];
  let adsDetail = null;
  if (!_.isEmpty(adsSection?.ads)) {
    adsDetail = adsSection.ads.filter((data) => data.ads_name === adsName)[0];
  }
  return adsDetail;
}
